export const COMPANY_CONTAINER = 936;
